import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const KybResultAsync = lazy(() => import('./ui'));

export const KybResult = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <KybResultAsync />
    </Suspense>
  );
};
